<template>
    <div>
        <kgr-empty
            v-if="locations.length === 0"
            :value="$t('Es wurden keine Ergebnisse gefunden.')"
        />

        <div v-else>
            <kgr-locations-table
                v-if="view === 'list'"
                :locations="locations"
                :filter="filter"
            />

            <kgr-locations-grid
                v-if="view === 'grid'"
                :locations="locations"
                :filter="filter"
            />
        </div>
    </div>
</template>

<script>
import EmptyData from '../common/EmptyData';
import KgrLocationsGrid from './LocationsGrid';
import KgrLocationsTable from './LocationsTable';

export default {
    name: 'KgrLocationList',
    components: {
        'kgr-locations-table': KgrLocationsTable,
        'kgr-locations-grid': KgrLocationsGrid,
        'kgr-empty': EmptyData,
    },
    props: {
        locations: {
            type: Array,
            required: true,
        },
        filter: {
            type: String,
            required: false,
            default: null,
        },
        view: {
            type: String,
            required: true,
        },

    },
}
</script>
